export default {
    auth: "Авторизироваться",
    reviews: "Отзывы",
    contacts: "Kontaktlar",
    help: "Помощь",
    calculator: "Калькулятор",
    choose_rate: "Пожалуйста, выберите тариф",
    delivery_calc: "Расчет стоимости доставки",
    lets_calc_delivery: "Давайте посчитаем примерную стоимость доставки",
    from_where: "Откуда",
    to_where: "Куда",
    required: "Это обязательно",
    weight: "Вес",
    price: "Стоимость",
    select_delivery_plan: "Выберите тарифный план доставки",
    delivery_calc_larges:
        "Расчет стоимости доставки крупногабаритных посылок",
    width: "Ширина",
    height: "Высота",
    length: "Длина",
    cost_air_transportation: "Стоимость авиаперевозки",
    delivery_times: "Сроки доставки",
    days: "дней",
    want_to_get_quick_answer:
        "Хотите быстро получить ответ на свой вопрос?\nИзучите раздел сайта Вопросы-ответы, в котором мы собрали ответы на самые популярные вопросы.\n\nЕсли ваш вопрос связан с тем, когда внесут входящую посылку в систему, то напоминаем, что на внесение груза нам нужно 1-2 рабочих дня, в редких случаях чуть больше. Советуем писать по этому вопросу только если груз не внесен более 3-х дней.",
    delivery_calc_2: "Посчитать доставку",
    cancel: "Отмена",
    back: "Назад",
    login_to_profile: "Войти в личный кабинет",
    registration: "Регистрация",
    entrance: "Вход",
    successfully_signin: "Успешный вход",
    phone_number: "Номер телефона",
    password: "Пароль",
    forgot_password: "Я забыл пароль",
    sign_in: "Войти в систему",
    name: "Имя",
    enter_name: "Введите имя",
    enter_your_firstname: "Введите свое имя",
    surname: "Фамилия",
    enter_surname: "Введите фамилия",
    birthday: "Дата рождения",
    day_month_year: "день.месяц.год",
    enter_your_lastname: "Введите свое фамилия",
    email: "Электронный адрес",
    enter_email: "Введите электронный адрес",
    document_type: "Тип документа будет",
    attach_photo_both_side: "Прикрепите фотографию с 2 сторон документа",
    upload_doc: "Добавить документ",
    green_card_number: "Серия и номер “Грин-карта”",
    repead_password: "Повторите пароль",
    passwords_must_match: "Пароли должны совпадать",
    please_enter_your_password:
        "Введите свой пароль, и повторите ввод пароля, чтобы исключить возможность опечатки.",
    all_files_required: "Все поля обязательны для заполнения",
    i_have_read_terms: "Я прочитал и согласен с Условиями использования",
    password_changed: "Пароль изменен",
    recover_password: "Восстановить пароль",
    we_have_send_code: "Мы отправили код на Ваш номер",
    please_enter_code: "Пожалуйста, введите код",
    code_must_5_chars: "Код должен состоять из 5 символов.",
    send_again: "Отправить ещё раз",
    confirm_number: "Подтвердите номер",
    get_your_personal_address: "Получите личный адрес в США прямо сейчас!",
    choose_products_online_store:
        "Выбирайте товары в интернет-магазинах США, Европы и Азии. Оформляйте доставку на ваш персональный адрес.",
    our_specialists:
        "Наши специалисты разработали удобный онлайн-калькулятор, который позволит вам быстро и точно определить цену на необходимые товары.",
    calculate: "Рассчитать",
    customer_support_7_day: "Поддержка клиентов 7 дней в неделю",
    we_are_always_in_touch:
        "Мы всегда на связи. Готовы выполнить любой ваш запрос или найдем достойную альтернативу Вы всегда можете рассчитывать на нашу помощь в любом вопросе",
    fast_and_reliable: "Быстрая и надежная\nдоставка по всему миру!",
    showing_delivery: "Показываем информацию по доставке",
    how_it_works: "Как всё\nработает",
    follow_four_steps:
        "Выполните четыре простых шага, чтобы\nполучить покупку из 30 стран",
    register_on_the_site:
        "Зарегистрируйтесь на сайте, чтобы получить\nперсональный адрес в США. Это займет 1 минуту.",
    get_personal_address: "Получить личный адрес",
    about_atlas: "О Atlas Express",
    deadline_6_year:
        "За короткий срок в 6 лет мы преобразовались из небольшого стартапа, занимающегося доставкой товаров из 30 различных стран, в крупнейшего и надежного мейлфорвардера. Наша компания теперь обладает собственными инновационными логистическими решениями, удобными автоматизированными складами, оборудованными самыми современными системами управления. Мы гордимся нашей командой профессионалов, которая распределена по всему миру, гарантируя надежную и эффективную работу нашего предприятия.",
    learn_more_how_work: "Подробнее о том, как мы работаем",
    here_are_reviews: "Вот что говорят наши клиенты",
    our_clients_are_satisfied: "Наши клиенты довольны нашими услугами",
    why: "Почему",
    costs: "стоит",
    choose: "выбрать",
    us: "нас",
    we_delivery_from_usa: "Доставляем из магазинов США",
    delivery_parcels_7_day:
        "Доставим ваши посылки от 7 дней и от $10, дадим возможность следить за процессом 24/7, проведем через таможню.",
    fair_and_transparent: "Честная и прозрачная система расчетов",
    logical_and_clear_system:
        "Логичная и понятная система расчетов за товары и услуги; Вы всегда в курсе, на что и как потрачены ваши деньги; Никаких скрытых платежей и доплат",
    you_always_know:
        "Вы всегда знаете, где сейчас находится ваша посылка и когда ее ждать",
    we_display_delivery:
        "Показываем информацию по доставке каждой партии в режиме реального времени.",
    parcel_storage: "Хранение посылок",
    more: "Подробнее",
    start_using: "Начать пользоваться",
    fast_and_reliable_2: "Быстрая и надежная доставка",
    we_guarantee:
        "Мы гарантируем быструю и надежную доставку вашего товара прямо к вам домой.",
    we_will_bring: "Мы привезём ваш товар из {{count}} стран",
    our_professionals_guarantee:
        "Наши профессионалы гарантируют быструю и надежную доставку вашего товара прямо к вашему порогу.",
    every_weekday_evening:
        "Каждый будний вечер мы рассылаем сводку новостей без белиберды и рекламы. Две минуты на чтение — и вы в курсе главных событий.",
    enter_your_email: "Введите ваш Email",
    subscribe: "Подписаться",
    service_foreign_stores:
        "Сервис доставки товаров из зарубежных магазинов",
    after_registration_30:
        "После регистрации вам доступны адреса наших складов в 30 странах мира.",
    about_company: "О компании",
    about_service: "О сервисе",
    tariffs_and_prices: "Тарифы и цены",
    our_services: "Наши услуги",
    customer_reviews: "Отзывы клиентов",
    sales: "Распродажи",
    track_your_parcel: "Отследить посылку",
    help_with_purchasing: "Помощь в покупке",
    restriction: "Ограничения и запреты",
    popular_stores: "Популярные магазины",
    delivery: "Доставка",
    sending_parcels: "Отправка посылок",
    customs_limits: "Таможенные лимиты",
    size_chart: "Таблица размеров",
    cost_calculation: "Расчет стоимости",
    usa_address: "Соединенные Штаты Америки 645 W 1st AveRoselle, NJ 07203",
    all_rights: "© 2025 ООО «Atlas Express». Все права защищены",
    we_use_cookie: "Мы используем файлы cookie для лучшего обслуживания.",
    home: "Главная",
    tariffs: "Тарифы",
    minimum: "Минимум",
    find_out_more: "Узнать больше",
    rate_kg: "${{price}} за 1 кг",
    price_unit: "${{price}} за 1 {{unit}}",
    rate_rate_kg: "${{price}} за 1 лб",
    services_prices: "Услуги и цены",
    the_shipping_price:
        "В стоимость отправки включено множество базовых бесплатных услуг.",
    in_addition_you_can_use:
        "Кроме того, вы можете воспользоваться дополнительными опциями: например, добавить дополнительную упаковку, измерить вещь и проверить работоспособность товара через систему спецзапросов или выбрать услугу “Помощь при покупке”.",
    consolidation: "Консолидация посылок",
    free: "Бесплатно",
    will_combine_all_your:
        "Бандеролька объединит все ваши покупки, не взяв за это ни цента. Вы можете отправить товары из разных интернет-магазинов одной посылкой, сэкономив на доставке.\n\nВнимание: товары, заказанные в Турции через «Помощь при покупке», невозможно объединить в одну отправку с самостоятельными заказами.",
    packaging: "Упаковочные материалы",
    incoming_up_to: "Входящих — до 45 дней бесплатно",
    store_incoming_parcels:
        "Хранить входящие посылки на складе Бандерольки можно бесплатно в течение 45 дней для складов США и Великобритании и 15 дней для складов в Германии и Турции, затем стоимость хранения составит $0.5 в день за посылку с первого дня платного хранения. Максимальный срок хранения входящей посылки — 100 дней. Если посылка не была востребована, по истечении 100 дней Бандеролька имеет право утилизировать её содержимое или распорядиться товарами по своему усмотрению.\n\nБесплатное хранение исходящих (сформированных) отправок на складе Бандерольки (с момента выставления счета на услуги) составляет семь дней, затем стоимость составит $2 в день. Общий срок хранения готовой к отправке посылки не должен превышать двух месяцев. Если такая посылка не была востребована, по истечении этого времени Бандеролька имеет право утилизировать её содержимое или распорядиться товарами по своему усмотрению.",
    sorting: "Сортировка",
    europe: "Европа",
    all: "Все",
    leisure: "Досуг",
    sport: "Спорт",
    home_and_garden: "Дом и сад",
    online_mall: "Интернет-магазин",
    health_beauty: "Здоровье и красота",
    jewelry_and_gifts: "Ювелирные изделия и подарки",
    office_supplies: "Канцелярские товары",
    products_for_animals: "Товары для животных",
    automobiles_and_accessories: "Автомобили и аксессуары",
    electronics_accessories: "Электроника и аксессуары",
    clothes_shoes_and_accessories: "Одежда обувь и аксессуары",
    baby_clothes_and_toys: "Детская одежда и игрушки",
    other: "Другой",
    start_shopping: "Начать покупки",
    nothing_found: "Ничего не найдено",
    sender_address: "Адрес отправителя",
    recipient_address: "Адрес получателя",
    working_days: "Рабочие дни",
    monday_friday: "с понедельника по пятницу",
    we_work_time: "Мы работаем с {{from}} до {{to}}",
    coordinates_will_added: "Координаты будут добавлены в ближайшее время.",
    payment: "Оплата",
    receipt: "Получение",
    purchases: "Покупки",
    frequently_questions: "Часто задаваемые вопросы",
    will_the_warehouse: "Будет ли склад в безналоговом штате?",
    we_are_working_on_it:
        "Мы работаем над этим и в скором времени запустим наш склад в безналоговом штате. После этого заказы будут обходиться вам дешевле :)",
    how_to_register: "Как зарегистрировать интернет заказ?",
    how_to_create_account: "Как создать личный кабинет?",
    what_days_do_you_ship: "В какие дни отправляете из США в Узбекистан?",
    my_office: "Мой кабинет",
    to_home: "На главную",
    or: "Или",
    my_parcels: "Мои посылки",
    my_addresses: "Мои адреса",
    my_balance: "Мой баланс",
    my_settings: "Мои настройки",
    log_out: "Выйти",
    contact_us: "Связаться с нами",
    are_you_sure_log_out: "Вы действительно хотите выйти?",
    no: "Нет",
    yes: "Да",
    your_free_wherehouse:
        "Ваши бесплатные адреса складов для онлайн покупок",
    parcels: "Посылки",
    addresses: "Адреса",
    balance: "Баланс",
    settings: "Настройки",
    online_order: "Интернет заказ",
    online_shopping: "Онлайн покупки",
    sent_parcels: "Отправленные посылки",
    outgoing_parcels: "Исходящие посылки",
    coming_soon_in_stock: "Ожидаемые и на складе",
    incoming_parcels: "Входящие посылки",
    orderStatus: {
        in_customer: "Ожидаемые",
        in_warehouse: "Подтверждено",
        shipped: "Отправленные",
        arrive_warehouse: "На складе",
        delivered: "Доставленны",
        location: "В складе"
    },
    shopOrderStatus: {
        process: "Ожидаемые",
        bought: "Купленные",
        verified: "Готов к отправке",
        accepted: "Одобренные",
    },
    information: "Информация",
    branch: "Филиал",
    delivery_cost: "Стоимость доставки",
    tariff_plan: "Тарифный план",
    paid: "Оплаченный",
    goods: "Товары",
    th: "шт",
    delivered: "Доставлено",
    order: "Заказ",
    status: "Статус",
    create_date: "Дата создания",
    arrival_date: "Дата прибытия",
    cost_of_goods: "Стоимость товаров",
    service: "Услуга",
    rate: "Тариф",
    tariff_cost: "Стоимость тарифа",
    leave_comment: "Оставить комментарий",
    additional_services: "Дополнительные услуги",
    remaining_payment: "Оставшаяся сумма платежа",
    total_cost_of_goods: "Общая стоимость товаров",
    delete_order: "Удалить заказ",
    decloration: "Декларация",
    parcel_name: "Название посылки",
    quantity: "Количество",
    are_you_sure_to_delete: "Вы уверены, что хотите удалить?",
    services_added_successfully: "Услуги успешно добавлены",
    you_can_choose_address_or_add:
        "Вы можете выбрать адрес получателя из сохранившехся адресов, либо добавить новый адрес",
    choose2: "Выбирать",
    bubble_sheet: "Пузырьковый лист",
    cardboard: "Картон",
    foam_plastic: "Пенопласт",
    add: "Добавить",
    update: "Обновить",
    successfully_deleted: "Успешно удалено",
    successfuly_updated: "Успешно обновлено",
    update_order: "Обновить заказ",
    product_name: "Название товара",
    add_more: "Добавить ещё",
    continue: "Продолжить",
    track_number: "Трек-номер",
    order_track_number: "Трек-номер заказа",
    link: "Ссылка",
    product_link: "Ссылка на продукт",
    example_game_console: "Пример: Игровая консоль",
    color: "Цвет",
    size: "Размер",
    save: "Сохранять",
    up_your_balance: "Пополнение баланса",
    up_your_balance2: "Пополнить баланс",
    current_balance: "Текущий остаток",
    amonut_you_want_to_up: "Сумма, которую вы хотите пополнить",
    enter_amount: "Введите сумму",
    next: "Далее",
    select_peyment_method: "Выберите метод оплаты",
    payment_amount: "Сумма оплаты",
    pay: "Оплатить",
    processing: "Обработка...",
    enter_code: "Введите код",
    code: "Код",
    card_number: "Номер карты",
    end_date: "Дата окончания",
    mm_yy: "ММ/ГГ",
    send: "Отправить",
    top_up: "Пополнить",
    balance2: "баланс",
    payment_was_successfully: "Оплата прошла успешно",
    comment: "Комментарий",
    trackingStatus: {
        pending: "В ожидании",
        accepted: "Одобренные",
    },
    special_services: "Специальные услуги",
    attention: "Внимание!",
    please_be_sure_fill_address:
        "Просим обязательно заполнить поле Address Line 2 во время оформления заказа в магазине. Поскольку оно является Вашим идентификационным кодом. Если не найдете соответсвующее поле, заполните рядом с Вашим именем.",
    latest_actions: "Последние действия",
    for_buyers: "Покупателям",
    useful: "Полезное",
    how_its_works: "Как всё работает",
    register: "Регистрируйтесь",
    which_side_country: "С какой стороны нужно доставить",
    address_owner: "Владелец адреса",
    region: "Регион",
    city_region: "Город / Район",
    street: "Улица",
    enter_street: "Введите улицу",
    house: "Дом",
    house_number: "Номер дома",
    apartment_office: "Квартира/офис",
    landmark: "Ориентир",
    see_the_landmark: "Видите ориентир или комментарии для курьера",
    add_pending_order: "Добавить ожидаемый заказ",
    customs_limit: "Таможенный лимит",
    sender_selection: "Выбор отправителя",
    recipient_selection: "Выбор получателя",
    choose_branch: "Выберите филиал",
    choose_country: "Выберите страну",
    cover_full_cost: "Покрыть полную стоимость посылки страховкой",
    service_cost: "Стоимость услуги",
    there_will_fedex:
        "За страховку будет взиматься дополнительная плата. Страховка сервисов FedEx/UPS не включает в себя страховку сервиса FGF",
    you_can_find_info_company:
        "Подробнее с тарифами вы можете ознакомиться на сайте компании",
    order_confirmation: "Подтверждения заказа",
    total_cost: "Общая стоимость",
    delivery_service: "Служба доставки",
    from_start_to_end: "С {{start}} по {{end}}",
    total_parcel_weight: "Общий вес посылки",
    comment_operator: "Комментарий для оператора",
    confirm_order: "Оформить",
    choose_order_type: "Выберите тип заказа",
    choose_delivery_type: "Выберите службу доставки",
    soon: "Скоро",
    kg: "кг",
    lb: "лб",
    "kg/sm": "кг",
    "lb/inc": "лб",
    day: "День",
    month: "Месяц",
    year: "Год",
    choose_delivery_time: "Выберите время доставки",
    fill_decloration: "Заполните декоарацию",
    please_describe_carefully:
        "Пожалуйста, внимательно опишите каждый товар в заказе. Эти данные будут использоваться для оформления таможенной декларации.",
    minimum_1: "Минимум – 1",
    specify_the_total_weight:
        "Укажите общий вес посылки (если знаете). Если не знаете, оставьте это поле пустым наш сотрудник взвесит вашу посылку на складе и сам заполнит это поле",
    edit: "Редактировать",
    new_order: "Новый заказ",
    open_until: "Открыто до",
    please_enter_current_pass:
        "Введите свой текущий пароль, новый пароль, и повторите ввод нового пароля, чтобы исключить возможность опечатки.",
    all_fileds_required: "Все поля обязательны для заполнения",
    pass_must_match: "Пароли должны совпадать.",
    enter_new_password: "Введите новый пароль",
    save_changes: "Сохранить изменения",
    new_address: "Новый адрес",
    add_new_address: "Добавить новый адрес",
    personal_info: "Личные данные",
    change_pass: "Сменить пароль",
    the_time_you_choose:
        "Выбранное вами время, в которое наш курьер сможет собрать посылку",
    paid2: "Оплачено",
    rates: "Тарифы",
    shops: "Магазины",
    services: "Услуги",
    January: "Январь",
    February: "Февраль",
    March: "Март",
    April: "Апрель",
    May: "Май",
    June: "Июнь",
    July: "Июль",
    August: "Август",
    September: "Сентябрь",
    October: "Октябрь",
    November: "Ноябрь",
    December: "Декабрь",
    incorrect_login_password: "Login yoki parol xato",
    take_shot_out: "Rasmga olish",
    hold_storage: "Хранить Omborda saqlash",
    get_back: "Orqaga qaytarish"
}